
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-search",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-search"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{staticClass:"cog-i-search__circle",attrs:{"d":"M7.5 12.75a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5z"}}),_c('path',{staticClass:"cog-i-search__line",attrs:{"d":"M15.75 15.75l-4.5-4.5"}})])])
          )
        }
      }
    